import artifact from '$houdini/artifacts/GenerateCrystalReportForSubscription'
import { MutationStore } from '../runtime/stores/mutation'

export class GenerateCrystalReportForSubscriptionStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
